import React, { useEffect, useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "sonner";
import { MASCOT_IMG } from "../../data/constants";

const SEQUENCE = ["ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a"];

// Konami code => full outbreak takeover of mascots raining down.
export const EasterEgg = () => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let idx = 0;
    const onKey = (e) => {
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === SEQUENCE[idx]) {
        idx++;
        if (idx === SEQUENCE.length) {
          idx = 0;
          setActive(true);
          toast("OUTBREAK UNLEASHED", { description: "You found the secret. The parasite thanks you." });
          setTimeout(() => setActive(false), 6000);
        }
      } else {
        idx = key === SEQUENCE[0] ? 1 : 0;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const drops = useMemo(
    () =>
      Array.from({ length: 40 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: 26 + Math.random() * 60,
        delay: Math.random() * 1.5,
        duration: 2.5 + Math.random() * 3,
        rotate: Math.random() * 360,
      })),
    []
  );

  return (
    <AnimatePresence>
      {active && (
        <div className="pointer-events-none fixed inset-0 z-[60] overflow-hidden" data-testid="easter-egg">
          {drops.map((d) => (
            <motion.img
              key={d.id}
              src={MASCOT_IMG}
              alt=""
              className="absolute"
              style={{ left: `${d.left}%`, width: d.size }}
              initial={{ y: -120, rotate: 0, opacity: 1 }}
              animate={{ y: "110vh", rotate: d.rotate }}
              transition={{ duration: d.duration, delay: d.delay, ease: "easeIn" }}
            />
          ))}
        </div>
      )}
    </AnimatePresence>
  );
};

export default EasterEgg;
